export interface AddressCoordinatesSource {
  coordinates?: number[];
  city?: {coordinates?: number[]};
  country?: {name?: string};
}

/** API GeoJSON order, including city fallback and Polish records saved before #389. */
export function getAddressCoordinates(address?: AddressCoordinatesSource): [number, number] | null {
  for (const candidate of [address?.coordinates, address?.city?.coordinates]) {
    let lon = Number(candidate?.[0]), lat = Number(candidate?.[1]);
    if (address?.country?.name === 'Polska' && lon >= 49 && lon <= 55 && lat >= 14 && lat <= 24) {
      [lon, lat] = [lat, lon];
    }
    if (Number.isFinite(lon) && Number.isFinite(lat) && (lon !== 0 || lat !== 0) &&
      lon >= -180 && lon <= 180 && lat >= -90 && lat <= 90) return [lon, lat];
  }
  return null;
}
